import {
  CLIENT_SET_CURRENT,
  CLIENT_SET_LIST,
  CLIENT_SET_AGREEMENTS,
  CLIENT_SET_ERROR,
  CLIENT_ORGANIZATIONS_LIST,
  CLIENT_ADD_TO_LIST,
  CLIENT_SET_INTEREST,
  CLIENT_ADD_TO_INTEREST,
  CLIENT_SET_DOC_TYPES,
} from './actionTypes';

const defaultState = {
  list: null,
  current: null,
  error: false,
  clientInterest: [],
  agreementsList: [],
  organizationsList: [],
  docTypeList: [],
};

export function client(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case CLIENT_SET_CURRENT:
      return { ...state, error: false, current: payload };

    case CLIENT_SET_LIST:
      return { ...state, error: false, list: payload };

    case CLIENT_ADD_TO_LIST: {
      const newList = state.list.slice();
      newList.unshift(payload);

      return { ...state, list: newList };
    }

    case CLIENT_ADD_TO_INTEREST: {
      const newList = state.clientInterest.slice();
      newList.push(payload);

      return { ...state, clientInterest: newList };
    }

    case CLIENT_SET_INTEREST:
      return { ...state, clientInterest: payload };

    case CLIENT_SET_ERROR:
      return { ...state, error: payload };

    case CLIENT_SET_AGREEMENTS:
      return { ...state, agreementsList: payload };

    case CLIENT_ORGANIZATIONS_LIST:
      return { ...state, organizationsList: payload };

    case CLIENT_SET_DOC_TYPES:
      return { ...state, docTypeList: payload };

    default:
      return state;
  }
}
